"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  errorDuringScopesFetch: {
    "id": "scopes.errorDuringScopesFetch",
    "defaultMessage": "An error occurred while fetching the scopes."
  },
  scopeIdPlaceholder: {
    "id": "scopes.scopeIdPlaceholder",
    "defaultMessage": "Enter an ID"
  },
  scopeName: {
    "id": "scopes.scopeName",
    "defaultMessage": "Name"
  },
  scopeNamePlaceholder: {
    "id": "scopes.scopeNamePlaceholder",
    "defaultMessage": "Choose a name"
  },
  scopeDescription: {
    "id": "scopes.scopeDescription",
    "defaultMessage": "Description"
  },
  scopeDescriptionPlaceholder: {
    "id": "scopes.scopeDescriptionPlaceholder",
    "defaultMessage": "Enter a description"
  },
  required: {
    "id": "scopes.required",
    "defaultMessage": "Required"
  },
  emphasize: {
    "id": "scopes.emphasize",
    "defaultMessage": "Emphasize"
  },
  showInDiscoveryDocument: {
    "id": "scopes.showInDiscoveryDocument",
    "defaultMessage": "Show in Discovery Document"
  },
  updateScope: {
    "id": "scopes.updateScope",
    "defaultMessage": "Update Scope"
  },
  deleteScope: {
    "id": "scopes.deleteScope",
    "defaultMessage": "Delete Scope"
  },
  deleteDesc: {
    "id": "scopes.deleteDesc",
    "defaultMessage": "Are you sure you want to delete this scope?"
  },
  deleteDesc2: {
    "id": "scopes.deleteDesc2",
    "defaultMessage": "This action cannot be undone."
  },
  addNewScope: {
    "id": "scopes.addNewScope",
    "defaultMessage": "Add new scope"
  },
  selectAScopeToUpdateIt: {
    "id": "scopes.selectAScopeToUpdateIt",
    "defaultMessage": "Select an scope to see or edit its details."
  },
  scopeSuccessfullyCreated: {
    "id": "scopes.scopeSuccessfullyCreated",
    "defaultMessage": "Scope was successfully created."
  },
  errorDuringScopeCreation: {
    "id": "scopes.errorDuringScopeCreation",
    "defaultMessage": "There was an error while creating a scope."
  },
  scopeAlreadyExists: {
    "id": "scopes.scopeAlreadyExists",
    "defaultMessage": "Scope with this ID already exists."
  },
  scopeSuccessfullyUpdated: {
    "id": "scopes.scopeSuccessfullyUpdated",
    "defaultMessage": "Scope was successfully updated."
  },
  scopeSuccessfullyDeleted: {
    "id": "scopes.scopeSuccessfullyDeleted",
    "defaultMessage": "Scope was successfully deleted."
  },
  errorDuringScopeUpdate: {
    "id": "scopes.errorDuringScopeUpdate",
    "defaultMessage": "There was an error while updating a scope."
  },
  errorDuringScopeDeletion: {
    "id": "scopes.errorDuringScopeDeletion",
    "defaultMessage": "There was an error while deleting a scope."
  }
});
exports.messages = messages;
//# sourceMappingURL=scopes-i18n.js.map